module.exports = __webpack_public_path__ + "img/PtownViews2019_19.d3ba848a.png";